import React from 'react';
import { Button, Grid } from "@material-ui/core";
import CachedIcon from "@material-ui/icons/Cached";

function StartNewEstimation(props:{clearEstimationData:Function})  {
    const { clearEstimationData } = props;
    return <Grid item xs={12} md={6}>
        <Button
            color="primary"
            size="small"
            variant="outlined"
            startIcon={<CachedIcon/>}
            onClick={() => {
                if (typeof clearEstimationData === "function") {
                    clearEstimationData();
                }
            }}
        >
            Start New Estimate
        </Button>
    </Grid>

}

export default StartNewEstimation;